import React from 'react';
import CriticalActionButton from '../CriticalActionButton/CriticalActionButton';

interface FixPlaceholderButtonProps {
  onClick: () => void;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
}

const FixPlaceholderButton: React.FC<FixPlaceholderButtonProps> = ({
  onClick,
  disabled = false,
  size = 'small'
}) => {
  return (
    <CriticalActionButton
      onClick={onClick}
      disabled={disabled}
      size={size}
      icon={
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 12.1875C11.4425 12.1875 10.9856 11.7452 10.9675 11.188L10.7906 5.74934C10.7684 5.06602 11.3163 4.5 12 4.5V4.5C12.6837 4.5 13.2316 5.06602 13.2094 5.74934L13.0325 11.188C13.0144 11.7452 12.5574 12.1875 12 12.1875V12.1875ZM5.84909 7.38307C5.17383 7.49002 4.72121 8.13478 4.85005 8.80622L5.87554 14.1503C5.9806 14.6978 6.50108 15.0631 7.05168 14.9759V14.9759C7.60229 14.8887 7.98439 14.3804 7.91512 13.8272L7.23902 8.42784C7.15407 7.74945 6.52436 7.27612 5.84909 7.38307V7.38307ZM7.63837 18.6799C8.32023 18.5719 8.78544 17.9316 8.67744 17.2498C8.56945 16.5679 7.92914 16.1027 7.24729 16.2107C6.56543 16.3187 6.10022 16.959 6.20822 17.6409C6.31622 18.3227 6.95652 18.7879 7.63837 18.6799ZM12 15.9375C12.6903 15.9375 13.25 15.3779 13.25 14.6875C13.25 13.9971 12.6903 13.4375 12 13.4375C11.3096 13.4375 10.75 13.9971 10.75 14.6875C10.75 15.3779 11.3096 15.9375 12 15.9375ZM16.9488 14.9754C16.3981 14.8882 16.016 14.3799 16.0853 13.8267L16.7614 8.42733C16.8464 7.74894 17.4761 7.2756 18.1513 7.38255V7.38255C18.8266 7.48951 19.2792 8.13427 19.1504 8.8057L18.1249 14.1498C18.0198 14.6972 17.4994 15.0626 16.9488 14.9754V14.9754ZM16.3621 18.6794C17.0439 18.7874 17.6842 18.3222 17.7922 17.6403C17.9002 16.9585 17.435 16.3182 16.7531 16.2102C16.0713 16.1022 15.431 16.5674 15.323 17.2493C15.215 17.9311 15.6802 18.5714 16.3621 18.6794Z"/>
        </svg>
      }
      text="Fix placeholders"
    />
  );
};

export default FixPlaceholderButton; 